export default "__VITE_ASSET__BavCcO_m__"